import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import { useParams } from 'react-router-dom'
import { useTitle } from 'react-use'
import useAuth from "../../core/Authentication/useAuth"
import config from "../../config.json"

export default function LogInTokenPage() {
    useTitle("Login - The Movie House TV")
    let { token, cid } = useParams();
    const auth = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        async function intData() {
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders
            }

            fetch(config.baseUrl, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        let json = result.json
                        if (result.ok) {
                            auth.login({
                                pin: json.pin,
                                username: json.email,
                                user_id: json.user_id,
                                token: token
                            })
                        }
                        else {
                            auth.logout()
                        }
                    },
                    (error) => {
                        console.error(error)
                    }
                ).finally(() => {
                    if (cid === "profile") {
                        navigate("/profile")
                    } else {
                        if (cid) localStorage.setItem("postBack-cid", cid)
                        navigate("/congratulations")
                    }
                })
        }

        intData()
    })

    return <TMHLoader />
}
